<div class="row">
  <div class="col-12">
    @if (newProgramFormat) {
      <form
        [formGroup]="form"
        (ngSubmit)="addProgramFormat(newProgramFormatObj)"
      >
        <div class="form-group input__container">
          <label for="name">Namn</label>
          <input
            name="name"
            type="text"
            formControlName="name"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <woo-dropdown
            [items]="publishers"
            formControlName="publisher_id"
            name="selectedPublisher"
            bindLabel="name"
            bindValue="id"
            inputId="publisher-search"
            labelText="Publicist *"
            [searchAttributes]="['name']"
            notFoundText="Inga publicister hittades."
            placeholder="Välj..."
            class="w-100"
          ></woo-dropdown>
        </div>

        <div class="form-group input__container">
          <label for="mrmId">MRM ID</label>
          <input
            name="mrmId"
            type="text"
            formControlName="mrm_id"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <woo-dropdown
            [items]="categories"
            formControlName="category_id"
            name="selectedCategory"
            bindLabel="name"
            bindValue="id"
            inputId="category-search"
            labelText="Kategori"
            [searchAttributes]="['name']"
            notFoundText="Inga kategorier hittades."
            placeholder="Välj..."
            class="w-100"
          ></woo-dropdown>
        </div>

        <div class="form-group input__container">
          <label for="omsName">OMS-namn</label>
          <input
            id="omsName"
            name="omsName"
            type="text"
            formControlName="oms_name"
            class="form-control"
          />
        </div>

        <p>Fördelning&nbsp;Preroll</p>

        <div class="row">
          <div class="form-group input__container col-2">
            <label for="input-longform">Adresserbar&nbsp;TV</label>
            <input
              name="input-longform"
              type="text"
              formControlName="longform"
              wooPercentFormatter
              [wooMinValidator]="0"
              [wooMaxValidator]="1"
              (change)="autofillShortform(form.get('longform').value)"
              class="form-control"
            />
          </div>

          <div class="form-group input__container col-2">
            <label for="input-shortform">Online&nbsp;Video</label>
            <input
              name="input-shortform"
              type="text"
              formControlName="shortform"
              wooPercentFormatter
              [wooMinValidator]="0"
              [wooMaxValidator]="1"
              (change)="autofillLongform(form.get('shortform').value)"
              class="form-control"
            />
          </div>
        </div>

        <div class="mt-3">
          <button
            type="submit"
            class="button primary-1"
            [disabled]="!form.valid"
          >
            Skapa
          </button>
          <button
            type="button"
            class="link"
            (click)="closeCard()"
          >
            Avbryt
          </button>
        </div>
      </form>
    }
  </div>
</div>
